// extracted by mini-css-extract-plugin
module.exports = {"core":"item-module--core--14NWz","header":"item-module--header--BHrHS","title":"item-module--title--3pg0g","icon":"item-module--icon--2CfDU"};